import WebApi from "@/views/loyalty/shared/modules/web_api"

export class JustpayQrcodePaymentEndpoint {
    constructor () {
        this.url = `${process.env.VUE_APP_JUSTPAY_URL}api/qrpayment/`
        this.webApi = new WebApi()
    }

    async checkBankState (orderId, sbpId, pointId) {
        await this.webApi.post(`${this.url}check_bank_payment`,
            { orderId: orderId, sbpId: sbpId, pointId: pointId })
    }

    // Create Bank order
    async createBankOrder (guid, pointId) {
        const ret = await this.webApi.post(`${this.url}CreateBankPayment`, { idempotency: guid, pointId: pointId })
        // console.log('createBankOrder ret', ret)
        if (ret) {
            if (!ret.status_code) {
                return ret.value
            } else {
                return null
            }
        } else {
            console.error(`Ошибка с кодом: ${ret.status_code}`)
        }
        return null
    }

    // async createPayment (orderId, pointId) {
    //     const ret = await this.webApi.post(`${this.url}create_payment`, { orderId: orderId, pointId: pointId })
    //     console.log('JustpayQrcodePaymentEndpoint createPayment ret', ret)
    //     if (ret) {
    //         if (ret.status_code === 200) {
    //             return true
    //         } else {
    //             return false
    //         }
    //     } else {
    //         console.error(`Ошибка с кодом: ${ret.status_code}`)
    //     }
    //     return false
    // }

    async getCheque (orderId) {
        const message = await this.webApi.post(`${this.url}GetCheque`,
            { orderId: orderId })
        console.log('message', message)
        if (message) {
            if (!message.status_code) {
                if (!message.error) {
                    return message
                } else {
                    return 'Не удалось получить чек'
                }
            } else {
                console.error(`Ошибка с кодом: ${message.status_code}`)
            }
        }
        return 'Не удалось получить чек'
    }

    async getOrderByNumber (orderNumber) {
        const ret = await this.webApi.get(`${this.url}GetOrderByNumber/${orderNumber}`)
        // console.log('getOrder ret', ret)
        if (ret) {
            if (!ret.status_code) {
                return ret
            } else {
                return null
            }
        } else {
            console.error(`Ошибка с кодом: ${ret.status_code}`)
        }
        return null
    }

    async getOrder (pointId) {
        const ret = await this.webApi.get(`${this.url}get_order/${pointId}`)
        // console.log('getOrder ret', ret)
        if (ret) {
            if (!ret.status_code) {
                return ret
            } else {
                return null
            }
        } else {
            console.error(`Ошибка с кодом: ${ret.status_code}`)
        }
        return null
    }

    async getQrcode (id) {
        const ret = await this.webApi.get(`${this.url}qrcode/${id}`)
        console.log('getQrcode ret', ret)
        if (ret) {
            if (!ret.status_code) {
                return ret.value
            } else {
                return null
            }
        } else {
            console.error(`Ошибка с кодом: ${ret.status_code}`)
        }
        return null
    }

    async getTimeout () {
        const ret = this.webApi.get(`${this.url}get_timeout`)
        if (ret) {
            if (!ret.status_code) {
                return ret
            } else {
                return 0
            }
        } else {
            console.error(`Ошибка с кодом: ${ret.status_code}`)
        }
        return 0
    }

    async getStatePaygineOrder (pointId, paygineOrderId) {
        const ret = this.webApi.get(`${this.url}get_state/${pointId}/${paygineOrderId}`)
        if (ret) {
            if (!ret.status_code) {
                return ret
            } else {
                return null
            }
        } else {
            console.error(`Ошибка с кодом: ${ret.status_code}`)
        }
        return null
    }

    async reGetBankOrder (pointId) {
        const ret = await this.webApi.get(`${this.url}ReGetBankOrder/${pointId}`)
        // console.log('reGetBankOrder ret', ret)
        if (ret) {
            if (!ret.status_code) {
                return ret.value
            } else {
                return null
            }
        } else {
            console.error(`Ошибка с кодом: ${ret.status_code}`)
        }
        return null
    }

    async sendCheque (orderId, email) {
        const message = await this.webApi.post(`${this.url}SendCheque`,
            { orderId: orderId, eMail: email })
        console.log('message', message)
        if (message) {
            if (!message.status_code) {
                if (!message.error) {
                    return message
                } else {
                    return 'Не удалось отправить чек по электронной почте'
                }
            } else {
                console.error(`Ошибка с кодом: ${message.status_code}`)
            }
        }
        return 'Не удалось отправить чек по электронной почте'
    }

    // set order to cancel state
    async setCancelState (orderId, sbpId, pointId) {
        await this.webApi.post(`${this.url}SetCancelState`,
            { orderId: orderId, sbpId: sbpId, pointId: pointId })
    }
}
